// @ts-ignore
import { v4 } from 'uuid'

const localStoragePersistenSessionKey = 'uss.id'

export class UserSession {
    readonly persistentSessionId: string

    constructor(storage: Storage) {
        const stored = storage.getItem(localStoragePersistenSessionKey)

        if (stored) {
            this.persistentSessionId = stored
        } else {
            const neu = this.genId()
            this.persistentSessionId = neu
            storage.setItem(localStoragePersistenSessionKey, neu)
        }
    }

    private genId = (): string => {
        const uuid = v4()

        // Too long ids are not good in logs
        return uuid.slice(0, 6)
    }

    getPersistentSessionId = (): string => this.persistentSessionId
}
